export enum AccountRole {
  ADMIN = 'admin',
  MEMBER = 'member'
}
